module.exports = __webpack_public_path__ + "static/media/mapPoint.8396fa08.svg";